import SavedPaymentMethodRowDetails from '~/components/payments/SavedPaymentMethodRowDetails';
import SectionHeading from '~/components/SectionHeading';
import { useState } from 'react';
import AddSavedCardPanel from '~/components/payments/AddSavedCardPanel';

const ClientSavedPaymentMethods = ({
    paymentMethods,
    refetch,
    className,
    client,
}) => {
    const [showAddCard, setShowAddCard] = useState(false);
    paymentMethods = paymentMethods || [];

    return (
        <div className={className}>
            <SectionHeading icon="$" name="Saved Cards" className="mb-4" />
            <div className="panel pl-6">
                {paymentMethods.map((method, idx) => (
                    <SavedPaymentMethodRowDetails
                        key={method.id}
                        paymentMethod={method}
                        refetch={refetch}
                        className={`py-3 pr-6 ${idx > 0 ? 'border-t' : ''}`}
                    />
                ))}
                {!paymentMethods?.length && (
                    <div className="text-gray-500 p-4">
                        There are no saved payment methods
                    </div>
                )}
            </div>
            <AddSavedCardPanel
                isOpen={showAddCard}
                onClose={() => setShowAddCard(false)}
                clientId={client.id}
            />
            <button
                type="button"
                className="btn-light-pill mt-2"
                onClick={() => setShowAddCard(true)}
            >
                Add Card
            </button>
        </div>
    );
};

export default ClientSavedPaymentMethods;
